export const keycloakDev = {
  url: 'https://id.stmtires.com/auth',
  realm: 'STM_Dev',
  clientId: 'STM_Inventory_Manager',
};

export const keycloakProd = {
  url: 'https://id.stmtires.com/auth',
  realm: 'STM_Prod',
  clientId: 'STM_Inventory_Manager',
};
